import Cookies from 'js-cookie'
import {encrypt, decrypt} from '@/util'
const infoKey = 'PEGncT' // 因为PENETRATION TEST随机命名，实际为Application-Token
const surveySubmit = 'Survey-Submit'
const intChallStatus = 'internship-challenge'
const surveyRedirectUrlKey = 'SurveyRedirectUrlKey'
const acceptPrivacy = 'AcceptPrivacy'
const icAssistantStatus = 'IcAssistantStatus'
const icAssistantAMStatus = 'icAssistantAMStatus'
const icAssistantPMStatus = 'icAssistantPMStatus'
const icTestStatus = 'icTestStatus'
const millisecond = new Date().getTime() // 当前的秒数

// infokey
export function getUserInfo() {
  const info = localStorage.getItem(infoKey)
  if(info){
    return JSON.parse(decrypt(info))
  }
  return {}
}

export function setUserInfo(info) {
  return localStorage.setItem(infoKey, encrypt(JSON.stringify(info)))
}

export function set30MinutesUserInfo(info) {
  const expireTime = new Date(millisecond + 0.5 * 60 * 60 * 1000) // 0.5小时，小于一天的写法
  return localStorage.setItem(infoKey, encrypt(JSON.stringify(info)),{
    expires: expireTime
  })
}

export function removeUserInfo() {
  return localStorage.removeItem(infoKey)
}
// survey redirect url
export function setSurveyRedirectUrl(info) {
  const expireTime = new Date(millisecond + 0.25 * 60 * 60 * 1000) // 0.25小时，小于一天的写法
  return Cookies.set(surveyRedirectUrlKey, JSON.stringify(info), {
    expires: expireTime
  })
}

export function getSurveyRedirectUrl() {
  const url = Cookies.get(surveyRedirectUrlKey) || localStorage.getItem(surveyRedirectUrlKey)
  if (url) {
    return JSON.parse(url)
  }
  return {}
}

export function removeSurveyRedirectUrl() {
  localStorage.removeItem(surveyRedirectUrlKey)
  return Cookies.remove(surveyRedirectUrlKey)
}

// surveySubmit
export function getSurveySubmit() {
  const info = Cookies.get(surveySubmit)
  if (info) {
    return JSON.parse(info)
  }
  return {}
}

// export function setSurveySubmit(info) {
//   return Cookies.set(surveySubmit, JSON.stringify(info))
// }

export function setCookSurveySubmit(info) {
  const protocol = window.location.protocol
  const expireTime = new Date(millisecond + 4 * 60 * 60 * 1000) // 4小时，小于一天的写法
  return Cookies.set(surveySubmit, JSON.stringify(info), {
    expires: expireTime,
    secure: protocol === 'https:',
    sameSite: 'strict'
  })
}

export function removeSurveySubmit() {
  return Cookies.remove(surveySubmit)
}

// internshipChallenge
export function getIntChallStatus() {
  const info = Cookies.get(intChallStatus)
  if (info) {
    return JSON.parse(info)
  }
  return {}
}

export function setCookIntChallStatus(info) {
  return Cookies.set(intChallStatus, JSON.stringify(info), {
    expires: 3 // 3天，大于1天的写法
  })
}

export function removeIntChallStatus() {
  return Cookies.remove(intChallStatus)
}

// acceptPrivacy
export function setAcceptPrivacy() {
  return Cookies.set(acceptPrivacy, '1', {
    expires: 3 // 3天，大于1天的写法
  })
}

export function getAcceptPrivacy() {
  return Cookies.get(acceptPrivacy)
}

// icAssistant
export function getIcAssistantStatus() {
  const info = Cookies.get(icAssistantStatus)
  if (info) {
    return JSON.parse(info)
  }
  return {}
}

export function setIcAssistantStatus(info) {
  return Cookies.set(icAssistantStatus, JSON.stringify(info), {
    expires: 1 // 1天，大于1天的写法
  })
}

export function setIcAssistantAMStatus(info) {
  return Cookies.set(icAssistantAMStatus, JSON.stringify(info), {
    expires: 1 // 1天，大于1天的写法
  })
}

export function getIcAssistantAMStatus() {
  const info = Cookies.get(icAssistantAMStatus)
  if (info) {
    return JSON.parse(info)
  }
  return {}
}

export function getIcAssistantPMStatus() {
  const info = Cookies.get(icAssistantPMStatus)
  if (info) {
    return JSON.parse(info)
  }
  return {}
}

export function setIcAssistantPMStatus(info) {
  return Cookies.set(icAssistantPMStatus, JSON.stringify(info), {
    expires: 1, // 1天，大于1天的写法
  })
}

// icTest
export function getIcTestStatus() {
  const info = Cookies.get(icTestStatus)
  if (info) {
    return JSON.parse(info)
  }
  return {}
}

export function setIcTestStatus(info) {
  return Cookies.set(icTestStatus, JSON.stringify(info), {
    expires: 3 // 3天，大于1天的写法
  })
}
